<template>
  <Modal v-bind="$attrs" v-on="$listeners" :fullScreenOnMobile="true">
    <template #title>箇所の並べ替え</template>

    <div class="sort-body">
      <!-- 説明は副題に置かない（共通の Modal は題名と横並びなので、小さいスマホでは 1 文字ずつ折れる） -->
      <div class="text-sm text-gray-500 mb-2">⋮⋮ をつかんで動かしてください</div>
      <!-- 完了した箇所も含めて全部並べる（番号は並びに合わせて振り直す） -->
      <draggable :list="rows" tag="div" handle=".row-drag-handle" direction="vertical" class="sort-list">
        <div v-for="(it, i) in rows" :key="it.id" class="sort-row" :class="{ 'is-client': it.clientSpecified, 'is-done': it.done }">
          <span class="row-drag-handle" title="つかんで並べ替え"><MenuIcon class="w-6 h-6" /></span>
          <span class="no">{{ i + 1 }}</span>
          <span class="flex-1 min-w-0 truncate font-bold">{{ it.item || '（箇所名なし）' }}</span>
          <span v-if="it.clientSpecified" class="tag"><StarIcon class="w-3 h-3" />お客様指定</span>
          <span v-if="it.done" class="tag tag-done">完了</span>
        </div>
      </draggable>
    </div>

    <template #action>
      <div class="flex items-center justify-end gap-3 w-full">
        <PrimaryButton text="キャンセル" size="normal bg-gray-400 hover:bg-gray-500" class="act-btn w-28 justify-center" :disabled="saving" @click="$emit('input', false)" />
        <PrimaryButton :text="saving ? '保存中…' : '保存'" class="act-btn w-28 justify-center" :disabled="saving" @click="save()" />
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import draggable from 'vuedraggable'
import { MenuIcon, StarIcon } from '@vue-hero-icons/solid'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'

export default {
  components: {
    Modal,
    PrimaryButton,
    draggable,
    MenuIcon,
    StarIcon
  },

  props: {
    // 開くたびに増える（開いたときに並びを取り直す）
    open: {
      type: Number,
      default: 0
    },
    // 報告書 id
    reportId: {
      type: Number,
      default: 0
    },
    // 報告書の箇所（今の並び）
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      saving: false,
      // 並べ替え中の行（元の配列は触らない）
      rows: []
    }
  },

  watch: {
    open() {
      this.rows = this.items.map((it) => ({ id: it.id, item: it.item, clientSpecified: !!it.clientSpecified, done: !!it.done }))
    }
  },

  methods: {
    /**
     * 並べた順を保存して親に返す
     * API: qualityReport/sortItems
     */
    async save() {
      const ids = this.rows.map((r) => r.id)
      this.saving = true
      try {
        await backend.postData('qualityReport/sortItems', { reportId: this.reportId, ids, userId: this.$store.getters.user.id })
      } catch (e) {
        console.log(e)
        this.saving = false
        await dialogs.showErrorDialog('保存失敗', 'エラー発生\r\n並びを保存できませんでした。')
        return
      }
      this.saving = false
      this.$emit('sorted', ids)
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.sort-body {
  width: 560px;
  max-width: 100%;
}

.sort-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* 1 行は 44px 以上（指でつかめる高さ） */
.sort-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 4px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  font-size: 16px;
}

.sort-row.is-client {
  border-color: #6ee7b7;
  background: #f0fdf4;
}

.sort-row.is-done {
  color: #6b7280;
}

.row-drag-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: #9ca3af;
  cursor: grab;
  flex-shrink: 0;
  touch-action: none;
}

.no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 9999px;
  background: #065f46;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  flex-shrink: 0;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
  background: #d1fae5;
  color: #047857;
  white-space: nowrap;
}

.tag-done {
  background: #e5e7eb;
  color: #4b5563;
}

.act-btn {
  min-height: 44px;
}
</style>
